import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChecklistPen = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "checklist-pen" }),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "8.25 4.949 5.55 8.549 3.75 6.749"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "8.25 13.649 5.55 17.249 3.75 15.449"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9.75,
			y1: 8.249,
			x2: 12.75,
			y2: 8.249
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9.75,
			y1: 17.249,
			x2: 12.75,
			y2: 17.249
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12.75.749H2.25a1.5,1.5,0,0,0-1.5,1.5v19.5a1.5,1.5,0,0,0,1.5,1.5h12"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.75,18.749a1.5,1.5,0,0,0,1.5,1.5h1.5a1.5,1.5,0,0,0,1.5-1.5V7.5h-4.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.25,2.249h1.5a1.5,1.5,0,0,1,1.5,1.5V10.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.25,7.5V2.249a1.5,1.5,0,0,0-1.5-1.5h-1.5a1.5,1.5,0,0,0-1.5,1.5V7.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 18,
			y1: 20.249,
			x2: 18,
			y2: 23.249
		})
	]
});
export default SvgChecklistPen;
